import {
    request,
    METHOD
} from '@/utils/request'
const baseUrl = process.env.VUE_APP_API_BASE_URL;

// 获取工作经验
export async function ProductTrialSave(params) {
    return request(baseUrl + '/guanwangs/ProductTrialSave', METHOD.POST, params,)
}